import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auto-generated',
  templateUrl: './auto-generated.component.html',
  styleUrls: ['./auto-generated.component.css']
})
export class AutoGeneratedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
